import {
  errorHandler,
  treatsItem,
  treatsItems,
} from '@/business/apiTreatment/response/baseAPITreatment';
import Technician from '@/store/modules/technicians/model';
import BaseService from '@/services/services/tools/baseService';
import TechniciansAPI from '@/services/api/internal/technicians.api';

const booleanFieldNames = ['mobile_user', 'scheduled'];
const treatListResponse = treatsItems({
  booleanFieldNames,
});
const TechniciansService = new BaseService({
  api: TechniciansAPI,
  treatCurrentResponse: (res) => {
    const response = {
      data: {
        items: res.data.items.filter(
          (el) =>
            el.phone_obsolete !== 'O' &&
            el.obsolete_subcontractor !== 'O' &&
            (!el.end_date || new Date(el.end_date) > new Date())
        ),
      },
    };
    if (!response.data.items.length) {
      return new Technician({});
    }
    return new Technician(
      treatsItem({
        booleanFieldNames,
      })(response)
    );
  },
  treatListResponse,
});

TechniciansService.findTechByIdx = (idx) => {
  const idxFilter = idx.map((id) => {
    return {
      id: { $eq: id },
    };
  });
  const q = {
    $or: idxFilter,
  };
  return TechniciansAPI.getItems({
    params: { q },
  })
    .then(treatListResponse)
    .catch(errorHandler);
};

export default TechniciansService;
